import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const LeastWantedLanguages: React.FC = () => {
  const data = [
    { language: 'JAVA', value: 34.25925925925926, fill: '#08306B' },
    { language: 'PHP', value: 26.851851851851855, fill: '#08306B' },
    { language: 'Python', value: 7.828282828282829, fill: '#08519C' },
    { language: 'JavaScript', value: 6.481481481481481, fill: '#08519C' },
    { language: 'C++', value: 6.313131313131313, fill: '#2171B5' },
    { language: 'Cobol', value: 5.892255892255893, fill: '#2171B5' },
    { language: 'C#', value: 5.723905723905724, fill: '#4292C6' },
    { language: 'C', value: 2.6094276094276094, fill: '#4292C6' },
    { language: 'Visual Basic', value: 2.525252525252525, fill: '#6BAED6' },
    { language: 'Ruby', value: 1.5151515151515151, fill: '#6BAED6' }
  ];

  return (
    <div>
      <StyledRecharts className="dark">
        <ResponsiveContainer height={400}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 40]}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default LeastWantedLanguages;
